<div class="chats">
    <div class="overview">
        <app-chat-overview #chatOverviewComponent (openChat)="openChat($event)" [currentChat]="currentChat">
        </app-chat-overview>
    </div>
    <div class="messaging">
        @if (currentChat) {
            <app-chat-messaging (openNextChat)="chatOverviewComponent.openNextChat()" [chat]="currentChat">
            </app-chat-messaging>
        } @else {
            <div class="placeholder">Selecteer een melding</div>
        }
    </div>
</div>
